import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Calendar } from "@phosphor-icons/react";

export default function MyAppointments() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/portal/appointments").then((r)=>setItems(r.data)); }, []);

  const today = new Date().toISOString().slice(0,10);
  const upcoming = items.filter(a => a.starts_at >= today);
  const past = items.filter(a => a.starts_at < today);

  return (
    <div data-testid="my-appointments">
      <h1 className="text-3xl sm:text-4xl font-black tracking-tighter" style={{fontFamily:"Manrope, sans-serif"}}>My appointments</h1>
      <p className="text-sm text-zinc-500 mt-1">All your upcoming and past visits.</p>

      <Section title="Upcoming" items={upcoming} empty="No upcoming visits scheduled. Request a consultation to book one."/>
      <Section title="Past" items={past} empty="No past visits yet." muted/>
    </div>
  );
}

function Section({ title, items, empty, muted }) {
  return (
    <div className="mt-8">
      <div className="text-[10px] uppercase tracking-[0.25em] font-black text-zinc-700 mb-3">{title}</div>
      {items.length === 0 ? (
        <div className="bg-white border border-zinc-200 rounded-sm p-6 text-sm text-zinc-500">{empty}</div>
      ) : (
        <div className="space-y-2">
          {items.map((a) => (
            <div key={a.id} className={`bg-white border border-zinc-200 rounded-sm p-4 flex items-center gap-4 ${muted?"opacity-70":""}`} data-testid={`p-appt-${a.id}`}>
              <Calendar size={22} weight="duotone" color="#E60000"/>
              <div className="flex-1 min-w-0">
                <div className="font-bold text-zinc-900">{a.treatment || "Consultation"}</div>
                <div className="text-xs text-zinc-500">{new Date(a.starts_at).toLocaleString()} {a.doctor && ` Â· ${a.doctor}`}</div>
              </div>
              <span className={`text-[10px] uppercase tracking-[0.2em] font-bold ${
                a.status === "scheduled" ? "text-blue-600"
                : a.status === "completed" ? "text-green-600"
                : a.status === "cancelled" ? "text-red-600"
                : "text-zinc-500"
              }`}>{a.status}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
